// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"59bc1179","594":"59bc1179","932":"976272f2"}[chunkId] + ".chunk.css";
};